var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSessionsPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.424C20 15.0455 19.7529 15.6417 19.3134 16.0812C18.874 16.5206 18.2777 16.7677 17.6562 16.7677H8.26042L5.24148 19.7866C5.0335 19.9946 4.72061 20.0573 4.44886 19.9448C4.1771 19.8322 4 19.5666 4 19.2724L4 6.3437C4 5.7222 4.24707 5.12601 4.68655 4.68654C5.12603 4.24707 5.72223 4 6.34375 4L17.6562 4C18.2778 4 18.874 4.24707 19.3134 4.68654C19.7529 5.12601 20 5.7222 20 6.3437V14.424Z",
    fill: "#FFCA9D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8322_330649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 6.16699C18.75 5.92388 18.6534 5.69046 18.4814 5.51855C18.3095 5.34665 18.0761 5.25 17.833 5.25L6.16699 5.25C5.92388 5.25 5.69046 5.34665 5.51855 5.51855C5.34665 5.69046 5.25 5.92388 5.25 6.16699L5.25 17.6895L7.30273 15.6367L7.41699 15.543C7.53928 15.4613 7.68382 15.4171 7.83301 15.417L17.833 15.417C18.076 15.417 18.3096 15.3202 18.4814 15.1484C18.6534 14.9765 18.75 14.7431 18.75 14.5V6.16699ZM20.25 14.5C20.25 15.1409 19.9952 15.7558 19.542 16.209C19.0888 16.6621 18.4739 16.917 17.833 16.917H8.14355L5.03027 20.0303C4.81579 20.2448 4.49313 20.3094 4.21289 20.1934C3.93263 20.0773 3.75 19.8033 3.75 19.5L3.75 6.16699C3.75 5.52605 4.00479 4.91122 4.45801 4.45801C4.91122 4.00479 5.52605 3.75 6.16699 3.75L17.833 3.75C18.4739 3.75 19.0888 4.00479 19.542 4.45801C19.9952 4.91122 20.25 5.52605 20.25 6.16699V14.5Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.08301C12.4141 7.08301 12.7498 7.41894 12.75 7.83301V9.58301H14.5C14.9141 9.58301 15.2498 9.91894 15.25 10.333C15.25 10.7472 14.9142 11.083 14.5 11.083H12.75V12.833C12.75 13.2472 12.4142 13.583 12 13.583C11.5858 13.583 11.25 13.2472 11.25 12.833V11.083H9.5C9.08579 11.083 8.75 10.7472 8.75 10.333C8.75018 9.91894 9.08589 9.58301 9.5 9.58301H11.25V7.83301C11.2502 7.41894 11.5859 7.08301 12 7.08301Z",
    fill: "#303030"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8322_330649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionsPageIcon);
export default __webpack_public_path__ + "static/media/sessions-page-icon.bdd7d0e53636635423e9a02db71eacfb.svg";
export { ForwardRef as ReactComponent };